import { useMemo } from "react";
import { useRestaurantData } from "../../provider/RestaurantDataContext"
import ItemDto from "../../models/ItemDto";
import ItemListCardItem from "../menuCard/subCategoryPage/ItemListCardItem";
import { Stack } from "@mui/material";

export default function AllItemsPage() {
    const { restaurantData: { categories, currency } } = useRestaurantData();

    const allItems = useMemo(() => {
        const itemSet = new Array<ItemDto>();
        categories.forEach(category => category.subCategories.forEach(subCategory =>
            subCategory.items.forEach(item => {
                if (!itemSet.some(itemInSet => itemInSet.id === item.id)) {
                    itemSet.push(item);
                }
            })
        ))
        return itemSet.sort((a, b) => a.id - b.id);
    }, [categories]);

    return (
        <Stack spacing={1} sx={{ marginTop: '1rem' }}>
            {
                allItems.map(item => <ItemListCardItem key={item.id} item={item} currency={currency} />)
            }
        </Stack>
    )
}